module.exports = __webpack_public_path__ + "img/cross.5baa8e62.svg";